import type { App } from 'vue';
import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import { piniaStoreReset } from './piniaStoreReset';

export { piniaStoreReset };

export const appPinia = createPinia();

appPinia.use(
  createPersistedState({
    storage: window.localStorage,
    auto: false,
  }),
);

appPinia.use(piniaStoreReset);

export default {
  install(app: App) {
    app.use(appPinia);
  },
};
